// ============================================================================
// MÓDULO UTILITÁRIO: VIDEO PROVIDER (FINOPS ENGINE)
// ARQUIVO: src/utils/VideoProvider.js
// OBJETIVO: Abstrair a lógica de player. Se for GRATUITO -> YouTube. Se for PAGO -> R2/Vimeo.
// ============================================================================

export const VideoProvider = {
    /**
     * Resolve a URL final do vídeo e o tipo de player
     * @param {string} videoId - Pode ser ID do YouTube (11 chars) ou URL completa
     * @param {boolean} isPremium - Se o usuário tem acesso PRO
     */
    resolve: (videoId, isPremium) => {
        if (!videoId) return { type: 'NONE', url: '' };

        // 1. YouTube (Padrão para IDs curtos ou URLs explícitas)
        // Custo: Zero. Uso: Aulas Isca / Gratuitas.
        if (videoId.length === 11 || videoId.includes('youtube.com') || videoId.includes('youtu.be')) {
            const cleanId = videoId.replace('https://youtu.be/', '').replace('https://www.youtube.com/watch?v=', '');
            return {
                type: 'YOUTUBE',
                url: `https://www.youtube.com/embed/${cleanId}?autoplay=0&rel=0&modestbranding=1`,
                isSecure: false
            };
        }

        // 2. Vimeo (Exige Premium)
        // Custo: Fixo (Assinatura Vimeo). Uso: Aulas Pro.
        if (videoId.includes('vimeo.com')) {
            if (!isPremium) return { type: 'LOCKED', url: '' };
            const cleanId = videoId.replace('https://vimeo.com/', '');
            return {
                type: 'VIMEO',
                url: `https://player.vimeo.com/video/${cleanId}`,
                isSecure: true
            };
        }

        // 3. Cloudflare R2 / S3 (Exige Premium & Signed URL - Futuro)
        // Custo: Baixo (Sem Egress Fees). Uso: Aulas Pro Alta Performance.
        if (videoId.includes('r2.cloudflarestorage.com') || videoId.endsWith('.mp4')) {
            if (!isPremium) return { type: 'LOCKED', url: '' };
            return {
                type: 'NATIVE',
                url: videoId, // Aqui entraria a lógica de Presigned URL no futuro
                isSecure: true
            };
        }

        // Fallback: Assume YouTube se não identificar padrão
        return {
            type: 'YOUTUBE',
            url: `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1`,
            isSecure: false
        };
    }
};